import React from "react";
import {
  InfoOutlined,
  ModeEditOutlineTwoTone,
  Add,
} from "@mui/icons-material";
import {
  Button,
  IconButton,
} from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import ReactHtmlParser from "html-react-parser";

import AppTable from "components/Shared/AppTable";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { BaseTabs } from "components/Shared/BaseTabs";
import { useTablePagination } from "hooks";

import { useLazyListBlogQuery } from "store/services/blogApi";

const BlogListScreen = () => {
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [{ title: "Blogs" }];

  const blogTabs = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  // RTK Query
  const [listBlogs, { data: blogListRes, isLoading, isFetching, error }] =
    useLazyListBlogQuery();

    console.log("blogs", blogListRes);

  React.useEffect(() => {
    listBlogs({
      active: activeTab === "Active",
      page: currentPage,
      limit: perPage,
      ...(keyword && { keyword }),
    });
  }, [activeTab, currentPage, listBlogs, keyword, perPage]);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <BaseTabs tabs={blogTabs} defaultValue={activeTab} />

        <TableFilter
          searchLabel="Title"
          disabled={isLoading || isFetching}
        >
          <div className="font-medium">{activeTab} Blogs</div>
        </TableFilter>

        <AppTable
          columns={columns}
          data={blogListRes?.data ?? []}
          progressPending={isLoading || isFetching}
          paginationPerPage={perPage}
          paginationTotalRows={blogListRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          expandableRows
          expandableRowsComponent={({ data }) => (
            <div className="p-2">
              {ReactHtmlParser(data?.content ?? "N/A")}
            </div>
          )}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default BlogListScreen;

// Actions
const PageActions = () => (
  <Link to="/app/crm/blog/create">
    <Button startIcon={<Add />} variant="contained" color="primary">
      New Blog
    </Button>
  </Link>
);

// Columns
const columns = [
  {
    name: "Title",
    selector: (row) => row?.title,
    cell: (row) => (
      <div title={row?.title} className="line-clamp-2">
        {row?.title}
      </div>
    ),
    sortable: true,
    minWidth: "250px",
  },
  {
    name: "Author",
    selector: (row) => row?.author,
  },
  {
    name: "Category",
    selector: (row) => row?.category?.name ?? "N/A",
  },
  {
    name: "Tags",
    selector: (row) => row?.tags,
  },
  {
    name: "Actions",
    cell: (row) => (
      <>
        <Link to={`/app/crm/blog/${row._id}/detail`}>
          <IconButton size="small" aria-label="View Blog" color="primary">
            <InfoOutlined />
          </IconButton>
        </Link>
        <Link to={`/app/crm/blog/${row._id}/edit`}>
          <IconButton size="small" aria-label="Edit Blog">
            <ModeEditOutlineTwoTone />
          </IconButton>
        </Link>
      </>
    ),
    ignoreRowClick: true,
    right: true,
  },
];
